// istanbul ignore file
import { Validate } from '@deporvillage/utils-library-component';

const Customer = {
    email: {
        id: 'email',
        type: 'email',
        label: 'form.label.email',
        value: null,
        event: 'login-popup-input-email',
        error: null,
        validate: [
            Validate.email,
        ],
    },
    password: {
        id: 'password',
        type: 'password',
        label: 'form.label.password',
        value: null,
        event: 'login-popup-input-password',
        error: null,
        validate: [
            Validate.required,
        ],
    },
};
export default Customer;
